module.exports = __webpack_public_path__ + "img/introductie_04_gadgets.628f3d9d.png";